<template>
  <v-app class="main-bg">
    <v-main>
      <v-container>
        <v-col>
          <h1>
            Max Point Of Sale Installation
            <small>(0.7 version)</small>
          </h1>
          <h5>
            For more help feel free to contact at
            <span class="error--text">info.codehas@gmail.com</span>
          </h5>
        </v-col>

        <template v-if="codehas.isValid">
          <v-row>
            <v-col class="4">
              <v-card outlined>
                <v-card-title>
                  <h3>Server requirements:</h3>
                </v-card-title>
                <v-card-text>
                  <v-alert
                    v-for="miss in requirements.missing"
                    :key="miss"
                    type="error"
                    class=" pa-1 mb-1"
                  >
                    {{ miss }}
                  </v-alert>
                  <v-alert
                    v-for="load in requirements.loaded"
                    :key="load"
                    type="success"
                    class=" pa-1 mb-1"
                  >
                    {{ load }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="4">
              <v-card
                outlined
                :loading="loading"
              >
                <v-card-title>
                  <h3>Fill valid server information:</h3>
                </v-card-title>
                <v-card-text>
                  <v-form
                    ref="form"
                    v-model="valid"
                    :disabled="missing"
                    lazy-validation
                    @submit.prevent="conectDatabase"
                  >
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="form.database_host"
                        hide-details="auto"
                        label="Database Host-name"
                        placeholder="Hostname"
                        outlined
                        dense
                        :rules="hostRules"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="form.database_port"
                        hide-details="auto"
                        label="Database Port"
                        placeholder="Database Port"
                        outlined
                        type="number"
                        dense
                        :rules="portRules"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="form.database_name"
                        hide-details="auto"
                        label="Database Name"
                        placeholder="Database Name"
                        outlined
                        dense
                        :rules="dbRules"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="form.database_user"
                        hide-details="auto"
                        label="Database User"
                        placeholder="Database User"
                        outlined
                        dense
                        :rules="userRules"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="form.database_password"
                        hide-details="auto"
                        label="Database Password"
                        placeholder="Database Password"
                        outlined
                        dense
                        type="password"
                      />
                    </v-col>
                    <template v-if="missing">
                      <v-alert
                        type="error"
                        dense
                      >
                        Fix server requirements and click to
                        <v-btn
                          class="info"
                          small
                          @click="preChecking"
                        >
                          Reload
                        </v-btn>
                      </v-alert>
                    </template>
                    <template v-else>
                      <v-col>
                        <v-btn
                          :disabled="!valid"
                          :loading="loading"
                          type="submit"
                          class="info"
                        >
                          Install
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          class="warning"
                          @click="resetForm"
                        >
                          Reset
                        </v-btn>
                      </v-col>
                    </template>

                    <v-col
                      cols="12"
                      class="pt-3"
                    >
                      <v-progress-linear
                        v-model="progress"
                        color="yellow"
                        height="42"
                        width="100%"
                        stream
                      />
                      <span
                        :class="feedClass + '--text'"
                      >{{ progress }}% {{ feedback }}</span>
                    </v-col>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="4"
              class="text-center"
            >
              <v-card outlined>
                <v-card-text>
                  <img
                    src="/installer/rose_finch.jpg"
                    width="300px"
                  >
                  <div class="mt-5">
                    <div class="text-left mt-2">
                      <p>
                        Use below login credentials and don't forget to change
                        password once installed successfully.
                      </p>
                      <ul>
                        <li><strong>User name : </strong>admin@admin.com</li>
                        <li><strong>Password : </strong>12345678</li>
                      </ul>

                      <p class="mt-5">
                        Thank you for purchasing.
                      </p>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row
            align="center"
            justify="center"
            class="mt-9 pt-9"
          >
            <v-col cols="6">
              <v-card>
                <v-card-title>
                  License Verification
                </v-card-title>
                <v-card-text>
                  <v-alert
                    v-if="codehas.feedback"
                    class="pa-1"
                    outlined
                    :type="codehas.class"
                  >
                    {{ codehas.feedback | capitalize }}
                  </v-alert>
                  <v-text-field
                    v-model.trim="codehas.license"
                    label="Enter License Key"
                    :loading="codehas.loading"
                    outlined
                    clearable
                    type="password"
                  />
                  <v-btn
                    class="info"
                    :loading="codehas.loading"
                    :disabled="codehas.license == ''"
                    @click="validcodehasKey"
                  >
                    Validate
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  data() {
    return {
      codehas: {
        encrypKey: "330505872085@codehas.com",
        current: null,
        license: "",
        isValid: false,
        feedback: "",
        class: "info--text",
        loading: false,
      },
      valid: true,
      hostRules: [(v) => !!v || "Host-name is required"],
      portRules: [(v) => !!v || "Database port is required"],
      dbRules: [(v) => !!v || "Database name is required"],
      userRules: [(v) => !!v || "Database user is required"],

      feedClass: "",
      feedback: "",
      progress: 0,
      loading: false,
      requirements: {
        missing: [],
        loaded: [],
      },
      form: {
        database_host: "127.0.0.1",
        database_port: 3306,
      },
    };
  },
  computed: {
    missing() {
      return this.requirements.missing.length !== 0;
    },
  },

  mounted() {
    this.preChecking();
    this.$data.codehas.current = "@" + window.location.host;
  },
  methods: {
    validcodehasKey() {
      this.codehas.loading = true;
      const decryptedText = this.CryptoJS.AES.decrypt(
        this.codehas.license,
        this.codehas.encrypKey
      ).toString(this.CryptoJS.enc.Utf8);

      if (decryptedText === this.codehas.current) {
        this.codehas.class = "success";
        this.codehas.feedback =
          "Awesome, it has been validated successfully ! ";
        setTimeout(() => {
          this.codehas.isValid = true;
        }, 2000);
      } else {
        this.codehas.class = "error";
        this.codehas.feedback = "Invalid license !";
        this.codehas.loading = false;
      }
    },

    /*----Parameters-----*/
    parameters(feed, prog, load, classFeed = "success") {
      this.feedback = feed;
      this.progress = prog;
      this.loading = load;
      this.feedClass = classFeed;
    },
    /*---end---*/
    /*-----preChecking----*/
    preChecking() {
      this.parameters("checking server requirements", "7", true);
      axios.post("install.php", { step: "step1" }).then((response) => {
        this.$data.requirements = response.data;
        this.parameters("Checked Server requirements", "17", false);
      });
    },
    /*---end---*/
    /*---Reset---*/
    resetForm() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    },
    /*---end----*/
    /*---Checking Database---*/
    conectDatabase() {
      if (this.$refs.form.validate()) {
        this.parameters("Connecting to database...", "23", true);
        this.form.step = "step3";
        axios
          .post("install.php", this.form)
          .then((response) => {
            this.parameters(response.data.message, 45, false);
            setTimeout(() => {
              this.setEnv();
            }, 1000);
          })
          .catch((error) => {
            this.parameters(error.response.data.message, "25", false, "error");
          });
      }
    },
    /*---end---*/
    /*------Setup Env------*/
    setEnv() {
      this.form.step = "step4";
      this.parameters("Setting .ENV file", 50, true);
      axios
        .post("install.php", this.form)
        .then((response) => {
          this.parameters(response.data.message, 57, false);
          setTimeout(() => {
            this.generateKey();
          }, 500);
        })
        .catch((error) => {
          this.parameters(error.response.data.message, 45, false, "error");
        });
    },
    /*---end---*/
    /*-----Generating Key------*/
    generateKey() {
      this.parameters("Generating key file", 60, true);
      axios
        .post("install.php", { step: "step5" })
        .then((res) => {
          this.parameters(res.data.message, 68, false);
          setTimeout(() => {
            this.initializationDb();
          }, 500);
        })
        .catch((error) => {
          this.parameters(error.response.data.message, 45, false, "error");
        });
    },
    /*-----end------*/
    /*---Initializing database---*/
    initializationDb() {
      this.parameters("Initializing database", 72, true);
      axios
        .post("install.php", { step: "step6" })
        .then((res) => {
          this.parameters(res.data.message, 87, false);
          setTimeout(() => {
            this.setPermissions();
          }, 500);
        })
        .catch((error) => {
          this.parameters(error.response.data.message, 65, false, "error");
        });
    },
    /*---end---*/
    /*----------Set Permissions-----------*/
    setPermissions() {
      this.parameters("Setting permissions", 90, true);
      axios
        .post("install.php", { step: "step7" })
        .then((res) => {
          this.parameters(res.data.message, 98, false);
          setTimeout(() => {
            this.redirectTo();
          }, 700);
        })
        .catch((error) => {
          this.parameters(error.response.data.message, 87, false, "error");
        });
    },
    /*------end-------*/
    /*---Redirecting-----*/
    redirectTo() {
      this.parameters("Installation completed", 100, true);
      setTimeout(() => {
        this.parameters("Redirecting to login in few seconds..", 100, false);
        window.location.href = "/login";
      }, 1500);
    },
    /*---end---*/
  },
};
</script>

<style type="text/css" scoped>
.main-bg {
  background-color: #f5f5f5;
}
</style>
